import React from "react";
import {
  IonCard,
  IonCardTitle,
  IonCardContent,
  isPlatform
} from "@ionic/react";
import i18n from "i18n";
import Commodity from "../Commodity/Commodity";
import { ComponentProps } from "./types";
import "./DetailsCommodities.scss";
import CommodityTitle from "../CommodityTitle/CommodityTitle";

export default ({ detailsCommodities }: ComponentProps) => {
  const isMobile = isPlatform("mobile") || isPlatform("mobileweb");

  return (
    <IonCard
      class="details-commodities-component"
      style={{ border: isMobile ? "none" : "0.5px solid #dedede" }}
      data-testid="ioncard"
    >
      <IonCardTitle
        className="title"
        data-testid="title"
        style={{ textAlign: isMobile ? "center" : "left" }}
      >
        {i18n.t("Commodities Details")}
      </IonCardTitle>
      <IonCardContent data-testid="ioncard-content">
        <CommodityTitle />
        {detailsCommodities.map((commodity, index) => (
          <Commodity
            commodity={commodity}
            key={`${commodity.commodityDesc}_${index}`}
            data-testid="commodity"
          />
        ))}
      </IonCardContent>
    </IonCard>
  );
};
